import React from "react";
import { Modal, Button } from "react-bootstrap";

const TermsModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Terms and Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <div id="popup_contents">
          <div id="popup_subtitle">
            <p>
              Minds AI Co., Ltd. (hereinafter referred to as “Company”) protects
              the personal information of information subjects in accordance
              with Article 30 of the Personal Information Protection Act to
              ensure that grievances related to this can be dealt with quickly
              and smoothly, we establish and disclose personal information
              processing guidelines as follows.
            </p>
          </div>
          <div id="1st">
            <strong>
              {" "}
              Article 1 (Purpose of processing personal information){" "}
            </strong>
            <p>
              The company processes personal information for the following
              purposes. Personal information being processed will not be used
              for purposes other than the following, and if the purpose of use
              changes, necessary measures will be taken, such as obtaining
              separate consent in accordance with Article 18 of the Personal
              Information Protection Act.
            </p>
            <p>
              1. Website membership registration and management
              <br />
              Confirmation of intention to become a member, customization and
              authentication according to the provision of membership services,
              maintenance and management of membership, confirmation of limited
              identity verification system search, prevention of use of service
              management, confirmation of consent of the legal representative
              when processing personal information of persons under the age of
              14, Personal information is processed for the purpose of
              requesting/notifying claims, handling grievances, etc.
            </p>
            <p>
              2. Provision of goods or services
              <br />
              We process personal information for the purposes of delivering
              goods, providing services, sending contracts and invoices,
              providing content, providing customized services, identity
              verification, age verification, bill payment and settlement, and
              debt collection.
            </p>
            <p>
              3. Grievance handling
              <br />
              Personal information is processed for the purposes of verifying
              the identity of the complainant, confirming the complaint,
              contacting and notifying for factual investigation, and notifying
              the result of processing.
            </p>
          </div>
          <div id="2nd">
            <strong>
              Article 2 (Processing and retention period of personal
              information)
            </strong>
            <p>
              ① The company processes and retains personal information within
              the personal information retention and use period in accordance
              with laws and regulations, or within the personal information
              retention and use period consented to when collecting personal
              information from the information subject.
              <br />② The processing and retention period for each personal
              information is as follows.
            </p>
            <p>
              1. Website membership registration and management: Until
              withdrawal of business/organization website
              <br />
              However, in the case of the following reasons, until the end of
              the relevant reason
              <br />
              1) If an investigation or investigation is in progress for
              violation of relevant laws or regulations, until the investigation
              or investigation is completed
              <br />
              2) If any claims or debts remain due to use of the website, until
              the relevant claims or debts are settled.
            </p>
          </div>
          <div id="3rd">
            <strong>
              Article 5 (Rights of users and legal representatives and methods
              of exercising them)
            </strong>
            <p>
              ① The information subject may exercise the following rights
              related to personal information protection against the company at
              any time.
              <br />
              1. Request to view personal information
              <br />
              2. Request for correction if there is an error, etc.
              <br />
              3. Request for deletion
              <br />
              4. Request to suspend processing
              <br />
              ② Rights pursuant to Paragraph 1 may be exercised to the Company
              in writing, by phone, e-mail, facsimile (FAX), etc., and the
              Company will take action without delay.
              <br />
              ③ If the information subject requests correction or deletion of
              errors in personal information, the company will not use or
              provide the personal information until correction or deletion is
              completed.
              <br />
              ④ Rights under paragraph 1 may be exercised through an agent, such
              as the information subject's legal representative or a person
              authorized to do so. In this case, you must submit a power of
              attorney in the format of Appendix 11 of the Enforcement Rules of
              the Personal Information Protection Act.
              <br />⑤ The information subject shall not violate the personal
              information and privacy of the information subject or others
              processed by the company in violation of relevant laws and
              regulations, such as the Personal Information Protection Act.
            </p>
          </div>
          <div id="4th">
            <strong>Article 6 (Personal information items processed)</strong>
            <p>
              The company processes the following personal information items.
            </p>
            <p>
              1. Website membership registration and management
              <br />
              Required items: name, date of birth, ID, password, address, phone
              number, gender, email address
            </p>
            <p>
              2. Provision of goods or services
              <br />
              Required items: Yes. Name, date of birth, gender, ID, password,
              phone number, email address
            </p>
            <p>
              3. The following personal information items may be automatically
              created and collected during the use of Internet services.
              <br />
              IP address, cookie, MAC address, service use record, visit record,
              bad use record, etc.
            </p>
          </div>
          <div id="5th">
            <strong>Article 7 (Destruction of personal information)</strong>
            <p>
              ① When personal information becomes unnecessary, such as when the
              personal information retention period has passed or the purpose of
              processing has been achieved, the company destroys the relevant
              personal information without delay.
              <br />
              ② If personal information must continue to be preserved pursuant
              to other laws and regulations despite the expiration of the
              personal information retention period consented to by the
              information subject or the purpose of processing has been
              achieved, the personal information shall be transferred to a
              separate database (DB) or stored in another storage location.
              Preserve.
              <br />
              ③ The procedures and methods for destroying personal information
              are as follows.
              <br />
              1. Destruction Procedure
              <br />
              The company selects the personal information that requires
              destruction and destroys the personal information with the
              approval of the company's personal information protection manager.
              <br />
              2. Method of destruction
              <br />
              The company destroys personal information recorded and stored in
              the form of electronic files using methods such as low level
              format so that the records cannot be reproduced, and personal
              information recorded and stored in paper documents is destroyed by
              shredding or incineration.
            </p>
          </div>
          <div id="6th">
            <strong>
              Article 8 (Measures to ensure the safety of personal information)
            </strong>
            <p>
              The company is taking the following measures to ensure the safety
              of personal information.
              <br />
              1. Management measures: Establishment and implementation of
              internal management plan, regular employee training, etc.
              <br />
              2. Technical measures: Management of access rights to personal
              information processing systems, installation of access control
              systems, encryption of unique identification information, etc.,
              installation of security programs.
              <br />
              3. Physical measures: Access control to computer rooms, data
              storage rooms, etc.
            </p>
          </div>
          <div id="7th">
            <strong>
              Article 9 (Matters regarding installation, operation and refusal
              of automatic personal information collection devices)
            </strong>
            <p>
              ① The company uses ‘cookies’ to store usage information and
              retrieve it from time to time in order to provide individualized
              services to users.
              <br />
              ② Cookies are a small amount of information that the server (http)
              used to run the website sends to the user's computer browser and
              are sometimes stored on the hard disk of the user's computer.
              <br />
              A. Purpose of use of cookies: They are used to provide optimized
              information to users by identifying visitation and usage patterns,
              popular search terms, secure access, etc. for each service and
              website visited by the user.
              <br />
              B. Installation, operation and refusal of cookies: You can refuse
              the storage of cookies through the option settings in the Tools →
              Internet Options → Personal Information menu at the top of the web
              browser.
              <br />
              C. If you refuse to store cookies, you may have difficulty using
              customized services.
            </p>
          </div>
          <div id="8th">
            <strong>
              Article 10 (Personal Information Protection Manager)
            </strong>
            <p>
              ① The company is responsible for overall management of personal
              information processing, and has designated a personal information
              protection manager as follows to handle complaints and provide
              relief for damage from information subjects related to personal
              information processing.
            </p>
            <p>
              ▶ Personal information protection officer
              <br />
              Name: Seok Jeong-ho
              <br />
              Position: CEO
              <br />
              Contact information: [Phone number: 1811-7642]
              <br />※ You will be connected to the personal information
              protection department.
            </p>
            <p>
              ② Information subjects may inquire about all personal information
              protection-related inquiries, complaint handling, damage relief,
              etc. that arise while using the company's services (or business)
              to the personal information protection manager and responsible
              department. The company will respond and process inquiries from
              information subjects without delay.
            </p>
          </div>
          <div id="9th">
            <strong>Article 11 (Request to view personal information)</strong>
            <p>
              The information subject may request access to personal information
              pursuant to Article 35 of the Personal Information Protection Act
              to the department below. The company will strive to promptly
              process the information subject's request to view personal
              information.
            </p>
            <p>
              ▶ Personal information access request reception and processing
              department
              <br />
              Name: Seok Jeong-ho
              <br />
              Position: CEO
              <br />
              Contact information: [Phone number: 1811-7642]
            </p>
          </div>
          <div id="10th">
            <strong>
              Article 12 (Methods for relief from rights infringement)
            </strong>
            <p>
              Information subjects can inquire about damage relief and
              consultation regarding personal information infringement to the
              organizations below.
            </p>
            <p>
              ▶ Personal Information Infringement Report Center (operated by
              Korea Internet & Security Agency)
              <br />
              - Responsibilities: Reporting personal information infringement,
              requesting consultation
              <br />
              - Homepage : privacy.kisa.or.kr
              <br />
              - Phone: (without area code) 118
              <br />- Address: Personal Information Infringement Reporting
              Center, 3rd floor, 9 Jinheung-gil, Naju-si, Jeollanam-do (58324)
              (301-2, Bitgaram-dong)
            </p>
            <p>
              ▶ Personal Information Dispute Mediation Committee
              <br />
              - Responsibilities: Request for personal information dispute
              mediation, group dispute mediation (civil resolution)
              <br />
              - Homepage : www.kopico.go.kr
              <br />
              - Phone: (without area code) 1833-6972
              <br />- Address: (03171) 4th floor, Seoul Government Complex, 209
              Sejong-daero, Jongno-gu, Seoul
            </p>
            <p>
              ▶ Supreme Prosecutors' Office Cyber ​​Crime Investigation Team:
              02-3480-3573 (www.spo.go.kr)
              <br />▶ National Police Agency Cyber ​​Security Bureau: 182
              (http://cyberbureau.police.go.kr)
            </p>
          </div>
          <div id="11th">
            <strong>
              Article 13 (Implementation and change of personal information
              processing policy)
            </strong>
            <p>This privacy policy is effective from May 6, 2020.</p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsModal;
